var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container",class:{relative:_vm.relative}},_vm._l((_vm.errors),function(e){return _c('div',{staticClass:"error",class:{success: e.tag === 'success'}},[_vm._v(_vm._s(e.msg)),_c('b-icon',{attrs:{"icon":"x"},on:{"click":function($event){return _vm.removeCurrent(e)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }